import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { ErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyBoardListView: FunctionComponent<{ idBoard: string }> = ({
  idBoard,
}) => {
  const BoardListView = useLazyComponent(
    () => import(/* webpackChunkName: "board-list-view" */ './BoardListView'),
    {
      preload: false,
      namedImport: 'BoardListView',
    },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-workflowers',
          feature: 'Board List View',
        }}
      >
        <BoardListView idBoard={idBoard} />
      </ErrorBoundary>
    </Suspense>
  );
};
